module.exports = __webpack_public_path__ + "img/customer3.c041f3c8.png";